import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { CustomerTaxResidencyModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { CountryCodeMap } from "../../../../../../Shared/Entities/Maps/CountryCodeMap";
import {
    RegulatoryHelper,
    TaxReferenceTypeMap_GBR,
    TaxReferenceTypeMap_SGP,
    TaxReferenceTypeMap_USA,
} from "../../../ClientRecord/Resource/RegulatoryCountryHelper";

interface ITaxResidencyProps extends IProcessComponentProps {
    data: CustomerTaxResidencyModel[];
    disableTax: boolean;
}

interface ITaxResidencyState {}

export class TaxResidency extends ProcessComponent<ITaxResidencyProps, ITaxResidencyState> {
    constructor(props: ITaxResidencyProps) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.data?.length === 1 || this.props.data?.length === 0) {
            this.addCountryComponent();
        }
    }

    private addCountryComponent(): void {
        const { data, onChange } = this.props;
        const changes = [...data];
        changes.push({ IsTaxResident: true ,Country:CountryCode.NotSpecified});
        onChange(changes);
    }

    private removeCountryComponent(index: number): void {
        const { data, onChange } = this.props;
        const changes = [...data];
        changes.splice(index, 1);
        onChange(changes);
    }

    private checkIndexNumber(): number {
        const { data } = this.props;
        const primaryTaxResident = data.find((ele) => ele.PrimaryTaxResidency);
        if (primaryTaxResident?.Country == CountryCode.GBR) {
            return 1;
        }
        return 0;
    }

    render() {
        const { data, onChange, disableTax } = this.props;

        return (
            <>
                {data &&
                    data.map((residency, index) => {
                        if (residency.Country === CountryCode.GBR) {return null;}
                        return (
                            <div key={`residency-${index}`}>
                                <div className="row">
                                    <div className="col-fluid col-max-430">
                                        <SelectEditor
                                            placeholder="Please select"
                                            cssWrapper="control-size-430"
                                            options={CountryCodeMap.getArray().filter((e) => {
                                                return e != CountryCode.GBR;
                                            })} // Remove UK option
                                            getText={(v) => CountryCodeMap.getString(v)}
                                            label="Country of tax residency"
                                            selected={residency.Country > -1 ? residency.Country : -1}
                                            disabled={disableTax}
                                            onChange={(v) => {
                                                const changes = [...data];
                                                changes[index].Country = v;
                                                changes[index].PrimaryTaxResidency = null;
                                                changes[index].TaxReferenceType = null;
                                                changes[index].TaxReference = null;
                                                onChange(changes);
                                            }}
                                            validationRules={[
                                                {
                                                    errorMessage: "Cannot select one country twice",
                                                    validator: (v) => {
                                                        return (
                                                            data.find((entry, i) => {
                                                                return i !== index && entry.Country === v;
                                                            }) === undefined
                                                        );
                                                    },
                                                },
                                            ]}
                                            required="Please select country of tax residency"
                                        />
                                    </div>
                                    {disableTax == false && (
                                        <>
                                            {index == this.checkIndexNumber() ? (
                                                <div className="col-auto pt-38">
                                                    {(data || []).filter(
                                                        (item) => item.IsTaxResident && item.Country != CountryCode.GBR
                                                    ).length < 5 && (
                                                        <button
                                                            className="add-button"
                                                            onClick={() => {
                                                                this.addCountryComponent();
                                                            }}
                                                        >
                                                            <span className="icon" aria-hidden="true" />
                                                            <span className="text">{"Add another tax residency"}</span>
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                <button
                                                    className="hyperlink"
                                                    onClick={() => {
                                                        this.removeCountryComponent(index);
                                                    }}
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </>
                                    )}
                                </div>
                                {RegulatoryHelper.getTaxReferenceTypes(residency.ActorType, residency.Country) !=
                                    null && (
                                    <div className="row">
                                        <div className="col-fluid col-max-430">
                                            <SelectEditor
                                                cssWrapper="control-size-430"
                                                placeholder="Please select"
                                                options={RegulatoryHelper.getTaxReferenceTypes(
                                                    residency.ActorType,
                                                    residency.Country
                                                )}
                                                getText={(v) => {
                                                    switch (residency.Country) {
                                                        case CountryCode.USA:
                                                            return TaxReferenceTypeMap_USA[v];
                                                        case CountryCode.GBR:
                                                            return TaxReferenceTypeMap_GBR[v];
                                                        case CountryCode.SGP:
                                                            return TaxReferenceTypeMap_SGP[v];
                                                    }
                                                }}
                                                label="Tax reference type"
                                                onChange={(v) => {
                                                    const changes = [...data];
                                                    changes[index].TaxReferenceType = v;
                                                    onChange(changes);
                                                }}
                                                required={"Please select a tax reference type"}
                                                alwaysValidateOnUpdate={false}
                                                disabled={disableTax}
                                                selected={residency.TaxReferenceType}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="row">
                                    <div className="col-fluid col-max-430">
                                        <TextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Tax Identification Number:"
                                            value={residency.TaxReference}
                                            required={"please enter"}
                                            alwaysValidateOnUpdate={false}
                                            disabled={disableTax}
                                            onChange={(v) => {
                                                const changes = [...data];
                                                changes[index].TaxReference = v;
                                                if (
                                                    residency.Country != CountryCode.USA &&
                                                    residency.Country != CountryCode.SGP
                                                ) {
                                                    changes[
                                                        index
                                                    ].TaxReferenceType = RegulatoryHelper.getDefaultTaxReferenceType(
                                                        residency.Country
                                                    );
                                                }
                                                onChange(changes);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </>
        );
    }
}
